import { render } from "./DADataTable copy.vue?vue&type=template&id=631a87b6"
import script from "./DADataTable copy.vue?vue&type=script&lang=js"
export * from "./DADataTable copy.vue?vue&type=script&lang=js"

import "./DADataTable copy.vue?vue&type=style&index=0&id=631a87b6&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__